export class ZeitslotBuchung {
    zeitslot_buchung_id: number;
    zeitslot_id: number;
    gruppe_id: number;
    gruppe_bezeichnung: string;
    status_id: number;
    status: string;
    schlachtdaten_id: number;
    tierzahl: number;
    benutzer_id_fahrer: number;
    standort: string;
    verzoegert: number;
    storniert: number;
    buchungs_datum: Date;
    aenderungs_datum: Date;
    geaendert_von: number;
    date_string: string;

    datum_uhrzeit_von: Date;
    datum_uhrzeit_bis: Date;
    anzahl_tiere: number;
    feiertage_einbeziehen: number;
    anzahl_wiederholungen: number;

    kunde_id_haendler: number;
    haendler_betrieb_id: number;
    haendler_bezeichnung: string;
    haendler_vvvo: string;
    haendler_strasse: string;
    haendler_plz: string;
    haendler_ort: string;
    haendler_ortsteil: string;
    haendler_telefon_1: string;
    haendler_mobil_1: string;
    haendler_fax: string;
    haendler_email: string;

    kunde_id_landwirt: number;
    landwirt_betrieb_id: number;
    landwirt_bezeichnung: string;
    landwirt_vvvo: string;
    landwirt_strasse: string;
    landwirt_plz: string;
    landwirt_ort: string;
    landwirt_ortsteil: string;
    landwirt_telefon_1: string;
    landwirt_mobil_1: string;
    landwirt_fax: string;
    landwirt_email: string;

    kunde_id_schlachthof: number;
    schlachthof_betrieb_id: number;
    schlachthof_bezeichnung: string;
    schlachthof_vvvo: string;
    schlachthof_strasse: string;
    schlachthof_plz: string;
    schlachthof_ort: string;
    schlachthof_ortsteil: string;
    schlachthof_telefon_1: string;
    schlachthof_mobil_1: string;
    schlachthof_fax: string;
    schlachthof_email: string;

    kunde_id_spediteur: number;
    spediteur_betrieb_id: number;
    spediteur_bezeichnung: string;
    spediteur_vvvo: string;
    spediteur_strasse: string;
    spediteur_plz: string;
    spediteur_ort: string;
    spediteur_ortsteil: string;
    spediteur_telefon_1: string;
    spediteur_mobil_1: string;
    spediteur_fax: string;
    spediteur_email: string;

    fahrer_vorname: string;
    fahrer_nachname: string;
}

export class ZeitSlot {
    zeitslot_id: number;
    kunde_id_schlachthof: number;
    datum_uhrzeit_von: Date;
    datum_uhrzeit_bis: Date;
    anzahl_tiere: number;
    feiertage_einbeziehen: number;
    anzahl_wiederholungen: number;
    rest_kapazitaet: number;
    gebuchte_kapazitaet: number;
}

export class ZeitSlotTag {
    day: Date;
    slots: ZeitSlot[];
}
